import styled from 'styled-components'

import { lightgray } from '../../styles/colors'

export const Bar = styled.div`
  width: calc(25% - 0.25rem);
  height: 0.25rem;
  border-radius: 0.5rem;
  background: ${props => (props.color ? props.color : lightgray)};
  margin-top: -0.75rem;
`

export const Flex = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
`

export const Text = styled.div`
  width: 100%;
  text-align: right;
  font-size: 14px;
  color: ${props => (props.color ? props.color : lightgray)};
`



// WEBPACK FOOTER //
// ./src/components/PasswordIndicator/styles.js